import React from 'react';
import { Card, Grid, Header1Text, SmallBodyText, Header3Text, Button, FlexRow, NavigationItem } from 'ui-toolkit';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons';
import { faEdit } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DateFormat, getDateString } from '../../ui-toolkit/utilities/getDateString';
import styled from 'styled-components';
import { ITaxCertificationData } from 'ui-toolkit/taxCertifications/ITaxCertification';
import { prettyTaxCertStatus } from 'ui-toolkit/taxCertifications/eTaxCertificationStatus';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { PrimaryHeader } from './styledComponents/PrimaryHeader';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';
import { useHasFeatureFlag } from '../../selectors/useHasFeatureFlag';

interface ITaxCertificationBlockProps {
  orderId: string;
  taxCert?: ITaxCertificationData;
  onSendTaxCertToSpruce: () => void;
}

const TaxCertCreateDiv = styled.div`
  padding-bottom: ${(props) => props.theme.spacing.spacing4};
  display: grid;
  grid-template-columns: min-content;
`;

export const TaxCertificationBlock: React.FC<ITaxCertificationBlockProps> = ({
  orderId,
  taxCert,
  onSendTaxCertToSpruce,
}) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  const { status, updatedAt } = taxCert || ({} as ITaxCertificationData);
  return (
    <Card title={'Tax Certification Information'}>
      {status ? (
        <Grid templateColumns={'min-content 1fr min-content'} alignItems={'center'}>
          <Header1Text>
            <FontAwesomeIcon icon={faFileAlt} />
          </Header1Text>
          <div>
            <Header3Text>Tax Certification Information</Header3Text>
            {updatedAt && (
              <SmallBodyText>Updated {getDateString(DateFormat.hugeDateTime, updatedAt, true)}</SmallBodyText>
            )}
          </div>
          <PrimaryHeader>
            <NavigationItem
              intent={'primary'}
              appearance={'default'}
              to={ClientUrlFactory().urlFor.taxCertification(eAccessControlUserType.Vendor, orderId, 'edit')}
              text={''}
            >
              <FontAwesomeIcon icon={faEdit} />
            </NavigationItem>
          </PrimaryHeader>
        </Grid>
      ) : (
        <TaxCertCreateDiv>
          <NavigationItem
            intent={'primary'}
            appearance={'primary'}
            to={ClientUrlFactory().urlFor.taxCertification(eAccessControlUserType.Vendor, orderId, 'create')}
            text={'Create'}
          />
        </TaxCertCreateDiv>
      )}
      <FlexRow>
        <>
          {status && (
            <Button intent={'primary'} disabled={true}>
              {prettyTaxCertStatus[status]} <FontAwesomeIcon icon={faEdit} />
            </Button>
          )}
        </>
        <Button intent={'primary'} onClick={() => onSendTaxCertToSpruce()}>
          Send Taxes To {isZillowClosingEnabled ? 'Zillow Closing' : 'Spruce'}
        </Button>
      </FlexRow>
    </Card>
  );
};
